import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import style from "./MobileCompletionCard.module.css";
import Icon from "@/ui/icon/Icon";
import { useLocalized } from "@/i18n/useLocalized";

function MobileCertificateCard({ course, certificateID }) {
	const { t } = useTranslation();
	const l = useLocalized();
	const ratio =
		course?.total_units != null
			? `${course.completed_units} / ${course.total_units}`
			: null;

	return (
		<Link
			to={`/certificates/${certificateID}`}
			className={`${style.card} ${style.compact} ${style.fadeIn}`}
		>
			<div className={`${style.iconBox} ${style.iconBoxFilled}`}>
				<Icon icon="fa-file-certificate" />
			</div>
			<div className={style.text}>
				<div className={style.subtitle}>
					<span>{t("courses:mobileCompletion.done")}</span>
					{ratio && (
						<>
							<span className={style.dot}>·</span>
							<span className={style.ratio}>{ratio}</span>
						</>
					)}
				</div>
				{course?.name && (
					<div className={style.title}>{l(course, "name")}</div>
				)}
			</div>
			<div className={style.linkAction}>
				<span>{t("courses:mobileCompletion.certificate")}</span>
				<Icon icon="fa-arrow-right" />
			</div>
		</Link>
	);
}

export default MobileCertificateCard;
